module.exports = __webpack_public_path__ + "static/media/beaconManageProductQueue.6c43a450.jpg";